import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchEntityListIfNeeded } from '../../../store/actions/entityTanActions.js'
import { ROLE_CAPABILITIES } from '../../../utils/role-capabilities.js'
import RuleSetting from '../Define/components/RuleSetting'
import SectionMaster from '../Define/components/SectionMaster'
import VendorMaster from '../Define/components/VendorMaster'
import SectionKeyword from './components/SectionKeyword'
import DuplicationRule from './components/DuplicationRule'
import { DEFAULT_PAGE } from '../../../constants/index.js'
const Define = () => {
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState('sectionMaster')
  const roleTypes = useSelector(state => state.user.role)

  const roleConfig = ROLE_CAPABILITIES[roleTypes] || ROLE_CAPABILITIES.default

  const tabs = [
    { id: 'sectionMaster', name: 'Section Master', component: SectionMaster },
    {
      id: 'sectionKeyword',
      name: 'Section Keywords',
      component: SectionKeyword,
    },
    { id: 'ruleSetting', name: 'Rule Setting', component: RuleSetting },
    { id: 'duplicationRule', name: 'Duplication Rule', component: DuplicationRule },

    { id: 'vendorMaster', name: 'Vendor Master', component: VendorMaster },
  ]

  useEffect(() => {
    const payload = {
      pageFilter: {
        currentPage: 1,
        includeCount: true,
        pageSize: DEFAULT_PAGE,
        sortField: 'entityName',
        sortOrder: 'ASC',
      },
      requestFilter: [],
      isReportDownload: false,
      searchCOList: [],
    }
    if (roleConfig.canCreate) {
      dispatch(fetchEntityListIfNeeded(payload))
    }
  }, [dispatch, roleConfig.canCreate])

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component

  return (
    <div>
      {/* Tabs Heading */}
      <div>
        <div className="flex space-x-0 gap-1 border-b border-[var(--border-subtel)] bg-[var(--bg-layer-1)]">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`p-3 text-sm relative cursor-pointer ${activeTab === tab.id
                ? 'text-[var(--forbrand-primary)] font-medium'
                : 'text-[var(--forbrand-secondary)] font-normal'
                }`}
            >
              {tab.name}
              {activeTab === tab.id && (
                <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[var(--forbrand-color)]"></div>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="p-0">
        {ActiveComponent && <ActiveComponent roleConfig={roleConfig} />}
      </div>
    </div>
  )
}

export default Define
